import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, IconButton, Stack } from '@mui/material';
import { Star as StarIcon, Block as BlockIcon } from '@mui/icons-material';

const OutletCard = ({ outlet, onTypeChange }) => {
  const isBlacklisted = outlet.type === 'blacklisted';
  const isFavourited = outlet.type === 'favourited';
  const isManaged = outlet.id !== undefined;

  // For unmanaged outlets, pass null as the ID
  const handleTypeChange = (newType) => {
    onTypeChange(isManaged ? outlet.id : null, newType, outlet.name);
  };

  return (
    <Box
      sx={{
        p: 2,
        display: 'grid',
        gridTemplateColumns: '1fr auto',
        alignItems: 'center',
        gap: 2,
        borderBottom: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Typography variant="body1" sx={{ fontWeight: 500 }}>
        {outlet.name}
      </Typography>
      <Stack direction="row" spacing={1} sx={{ justifyContent: 'flex-end' }}>
        <IconButton
          size="small"
          onClick={() => handleTypeChange(isFavourited ? null : 'favourited')}
          aria-label="favourite"
          title={isFavourited ? 'Remove from favourites' : 'Add to favourites'}
          sx={{
            width: 35,
            height: 35,
            minWidth: 35,
            minHeight: 35,
            backgroundColor: isFavourited ? 'primary.main' : 'transparent',
            border: '1px solid',
            borderColor: isFavourited ? 'primary.main' : 'divider',
            color: isFavourited ? 'white' : 'action.active',
            '&:hover': {
              backgroundColor: isFavourited ? 'primary.dark' : 'action.hover',
            },
            p: 0,
            '& .MuiSvgIcon-root': {
              m: 0,
            },
          }}
        >
          <StarIcon sx={{ fontSize: 18 }} />
        </IconButton>
        <IconButton
          size="small"
          onClick={() => handleTypeChange(isBlacklisted ? null : 'blacklisted')}
          aria-label="blacklist"
          title={isBlacklisted ? 'Remove from blacklist' : 'Add to blacklist'}
          sx={{
            width: 35,
            height: 35,
            minWidth: 35,
            minHeight: 35,
            backgroundColor: isBlacklisted ? 'error.main' : 'transparent',
            border: '1px solid',
            borderColor: isBlacklisted ? 'error.main' : 'divider',
            color: isBlacklisted ? 'white' : 'action.active',
            '&:hover': {
              backgroundColor: isBlacklisted ? 'error.dark' : 'action.hover',
            },
            p: 0,
            '& .MuiSvgIcon-root': {
              m: 0,
            },
          }}
        >
          <BlockIcon sx={{ fontSize: 18 }} />
        </IconButton>
      </Stack>
    </Box>
  );
};

OutletCard.propTypes = {
  outlet: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['favourited', 'blacklisted', null]),
  }).isRequired,
  onTypeChange: PropTypes.func.isRequired,
};

export default OutletCard;
